import * as React from 'react';

export const DocumentsTab = () => {
  return <div>TBA tab content: DocumentsTab</div>;
};
